import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Keyboard shortcuts cheat sheet. Triggered by pressing `?` anywhere in
 * the app (while the launcher is expanded). Renders centred over the
 * page; Esc / click backdrop dismisses.
 */
import { IconClose } from "./icons.js";
const SHORTCUTS = [
    {
        group: "Capture",
        items: [
            { keys: ["Click"], label: "Annotate element" },
            { keys: ["Drag"], label: "Select area" },
            { keys: ["Select text"], label: "Annotate text" },
            { keys: ["⇧", "Click"], label: "Multi-select" },
            { keys: ["Esc"], label: "Cancel / close" },
            { keys: ["↵"], label: "Add (in card)" },
            { keys: ["⇧", "↵"], label: "Newline (in card)" },
        ],
    },
    {
        group: "Toolbar",
        items: [
            { keys: ["P"], label: "Pause animations" },
            { keys: ["H"], label: "Hide markers" },
            { keys: ["⇧", "C"], label: "Copy markdown" },
            { keys: ["⇧", "X"], label: "Clear annotations" },
            { keys: ["L"], label: "Layout mode" },
        ],
    },
    {
        group: "Markers",
        items: [
            { keys: ["Click"], label: "Remove" },
            { keys: ["Right-click"], label: "Edit" },
        ],
    },
    {
        group: "App",
        items: [{ keys: ["?"], label: "This panel" }],
    },
];
const KeyChip = ({ value }) => {
    const isWord = value.length > 1 && !/^[⇧↵⌘⌥⌃]+$/.test(value);
    return (_jsx("kbd", { className: isWord
            ? "px-1.5 h-5 inline-flex items-center rounded bg-black/40 text-[10px] uppercase tracking-wider text-hc-ink/85 ring-1 ring-inset ring-white/10"
            : "min-w-[20px] h-5 px-1 inline-flex items-center justify-center rounded bg-black/40 text-[11px] font-semibold text-hc-ink/85 ring-1 ring-inset ring-white/10 font-mono", children: value }));
};
export const ShortcutsPanel = ({ onClose }) => (_jsxs(_Fragment, { children: [_jsx("div", { onClick: onClose, className: "pointer-events-auto fixed inset-0 z-[2147483647] bg-black/40", "aria-hidden": true }), _jsxs("div", { role: "dialog", "aria-label": "Keyboard shortcuts", className: "pointer-events-auto fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[440px] max-w-[calc(100vw-24px)] max-h-[calc(100vh-24px)] z-[2147483647] rounded-xl bg-hc-surface ring-1 ring-hc-line/80 shadow-card animate-hc-pop overflow-hidden flex flex-col", children: [_jsxs("header", { className: "shrink-0 flex items-center justify-between px-4 py-3 border-b border-hc-line/60", children: [_jsx("span", { className: "text-[12px] uppercase tracking-wider text-hc-mute", children: "Keyboard shortcuts" }), _jsx("button", { type: "button", onClick: onClose, className: "h-6 w-6 grid place-items-center rounded-md text-hc-mute hover:text-hc-ink hover:bg-white/[0.06]", title: "Close (Esc)", children: _jsx(IconClose, { width: 12, height: 12 }) })] }), _jsx("div", { className: "flex-1 min-h-0 overflow-y-auto px-4 py-3 space-y-4", children: SHORTCUTS.map((g) => (_jsxs("section", { children: [_jsx("h3", { className: "text-[10px] uppercase tracking-wider text-hc-mute mb-1.5", children: g.group }), _jsx("ul", { className: "space-y-1", children: g.items.map((s, i) => (_jsxs("li", { className: "flex items-center justify-between gap-3 text-[12px]", children: [_jsx("span", { className: "text-hc-ink/90", children: s.label }), _jsx("span", { className: "flex items-center gap-1 shrink-0", children: s.keys.map((k, ki) => (_jsx(KeyChip, { value: k }, ki))) })] }, `${g.group}-${i}`))) })] }, g.group))) }), _jsxs("footer", { className: "shrink-0 px-4 py-2.5 border-t border-hc-line/60 text-[10px] text-hc-mute", children: ["Press ", _jsx(KeyChip, { value: "?" }), " any time to reopen \u00B7", " ", _jsx(KeyChip, { value: "Esc" }), " to dismiss"] })] })] }));
//# sourceMappingURL=ShortcutsPanel.js.map